import React, { useContext, useState } from 'react';
import { getWebsiteBaseUrl, getLang } from './../../shared/utils/environment.js';
import { ask__ } from './../../shared/utils/i18n.js';
import { GlobalErrorContext } from './../../shared/context/GlobalErrorContext.js';
import { GlobalIsRegisteredContext } from '../../shared/context/GlobalIsRegistered.js';
import { GlobalUserContext } from '../../shared/context/GlobalUserContext.js';

import Reservations from '../Reservations/Reservations';
import Login from '../Login/Login';

import './Chat.scss';

export default function Chat(props) {

  const {setGlobalError} = useContext(GlobalErrorContext);
  const {getGlobalIsRegistered} = useContext(GlobalIsRegisteredContext);
  const {getGlobalUser} = useContext(GlobalUserContext);

  return (<>
    {getGlobalUser.isLoggedIn && getGlobalIsRegistered ? <>
      <div className="chat">
        <h2>{ ask__('Navigation: Chat') }</h2>
        <div className="chat__description" dangerouslySetInnerHTML={{__html: (window.ortonWebsiteData.i18n.chat || '')}}></div>
        <div className="chat__reservations">
          <h2>{ ask__('Booking: Upcoming remotes') }</h2>
          <Reservations type="upcoming-video-reception" />
        </div>
      </div>
      </> : <>
        <Login type="generic" />
      </>}
    </>
  )

}
